<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "organizationWrapper"
};
</script>

<style scoped></style>
